module.exports = __webpack_public_path__ + "static/media/Post Street, San Francisco, CA4.0b9f6f67.jpg";